import React from 'react'
import { useDragStore } from './DragContext'
import shortid from 'shortid'

export default ({
  children,
  onDragDelayStart,
  onDragStart,
  onDrag,
  onDragEnd,
  onMouseDown,
  onTouchStart,
  disabled,
  delay = 6,
  innerRef,
  data,
  type,
  ...rest
}) => {
  const dragStore = useDragStore()
  const startCoordinates = React.useRef(null)
  const offset = React.useRef()
  const wrapper = React.useRef()
  const draggableId = React.useRef(shortid.generate())

  const getOffsetCoordinates = e => {
    const { clientX, clientY } = e
    return { x: clientX, y: clientY }
  }

  const updateCoordinates = e => {
    const coordinates = getOffsetCoordinates(e)
    if (onDrag) {
      onDrag(coordinates, e)
    }
  }

  const stopDrag = e => {
    dragStore.dispatch.stopDrag()
    const coordinates = getOffsetCoordinates(e)
    if (onDragEnd) {
      onDragEnd(e, coordinates)
    }
    window.removeEventListener('mouseup', stopDrag)
    window.removeEventListener('mousemove', updateCoordinates)
  }

  const startDrag = e => {
    if (onDragStart) {
      onDragStart(e)
    }
    dragStore.dispatch.startDrag({
      id: draggableId.current,
      data,
      type
    })
    const nodeRect = wrapper.current.getBoundingClientRect()
    offset.current = {
      x: startCoordinates.current.x - nodeRect.left,
      y: startCoordinates.current.y - nodeRect.top
    }
    window.addEventListener('mouseup', stopDrag)
    window.addEventListener('mousemove', updateCoordinates)
  }

  const checkDragDelay = e => {
    let x
    let y
    if ('ontouchstart' in window && e.touches) {
      x = e.touches[0].clientX
      y = e.touches[0].clientY
    } else {
      e.preventDefault()
      x = e.clientX
      y = e.clientY
    }
    let a = Math.abs(startCoordinates.current.x - x)
    let b = Math.abs(startCoordinates.current.y - y)
    let distance = Math.round(Math.sqrt(Math.pow(a, 2) + Math.pow(b, 2)))
    let dragDistance = delay
    if (distance >= dragDistance) {
      startDrag(e)
      endDragDelay()
    }
  }

  const endDragDelay = () => {
    document.removeEventListener('mouseup', endDragDelay)
    document.removeEventListener('mousemove', checkDragDelay)
    startCoordinates.current = null
  }

  const startDragDelay = e => {
    if (onDragDelayStart) {
      onDragDelayStart(e)
    }
    //e.stopPropagation()
    let x
    let y
    if ('ontouchstart' in window && e.touches) {
      x = e.touches[0].clientX
      y = e.touches[0].clientY
    } else {
      //e.preventDefault()
      x = e.clientX
      y = e.clientY
    }
    startCoordinates.current = { x, y }
    document.addEventListener('mouseup', endDragDelay)
    document.addEventListener('mousemove', checkDragDelay)
  }

  return (
    <div
      onMouseDown={e => {
        if (!disabled) {
          startDragDelay(e)
        }
        if (onMouseDown) {
          onMouseDown(e)
        }
      }}
      onTouchStart={e => {
        if (!disabled) {
          startDragDelay(e)
        }
        if (onTouchStart) {
          onTouchStart(e)
        }
      }}
      onDragStart={e => {
        e.preventDefault()
        e.stopPropagation()
      }}
      ref={ref => {
        wrapper.current = ref
        if (innerRef) {
          innerRef.current = ref
        }
      }}
      {...rest}
    >
      {children}
    </div>
  )
}
